import { ILayoutFilter } from '@base/@types/components/Layout/Filters'

export const reportFilter: ILayoutFilter[] = [
  {
    id: 'empresaIds',
    label: 'Empresa',
    type: 'checkbox'
  },
  {
    id: 'empresaSelectIds',
    label: '',
    filterId: 'companies',
    type: 'select',
    isMulti: true
  },
  {
    id: 'centroCdLojaIds',
    label: 'Centro (CD/Loja)',
    type: 'checkbox'
  },
  {
    id: 'centroCdLojaSelectIds',
    label: '',
    filterId: 'centers',
    type: 'select',
    isMulti: true
  },
  {
    id: 'categoriasIds',
    label: 'Categoria Compacta',
    type: 'checkbox'
  },
  {
    id: 'categoriasSelectIds',
    label: '',
    filterId: 'compactCategories',
    type: 'select',
    isMulti: true
  },
  {
    id: 'anosIds',
    label: 'Ano',
    type: 'checkbox'
  },
  {
    id: 'anosSelectIds',
    label: '',
    filterId: 'yearBudget',
    type: 'select',
    isMulti: true
  },
  {
    id: 'mesesIds',
    label: 'Mês',
    type: 'checkbox'
  },
  {
    id: 'mesesSelectIds',
    label: '',
    filterId: 'monthBudget',
    type: 'select',
    isMulti: true
  },
  {
    id: 'historicoIds',
    label: 'Historico',
    type: 'checkbox'
  },
  {
    id: 'historicoSelectIds',
    label: '',
    filterId: 'historicBudget',
    type: 'select',
    isMulti: true
  },
  {
    id: 'operacaoIds',
    label: 'Operação',
    type: 'checkbox'
  },
  {
    id: 'operacaoSelectIds',
    label: '',
    filterId: 'managerOperations',
    type: 'select',
    isMulti: true
  },
  {
    id: 'visualizationIds',
    label: 'Visualização',
    filterId: 'visualization',
    type: 'select'
  },
  {
    id: 'dimensaoIds',
    label: 'Dimensão',
    filterId: 'dimension',
    type: 'select'
  }
]
